import * as ReactVirtualized from 'react-virtualized';

/**
 *  React-virtualized is used to scroll through large data sets using List, Table, Grid, Collection etc.
 */

export default ReactVirtualized;
